import { useMemo } from 'react';
import { formatDistanceToNow } from 'date-fns';
import { CoreState, DeploymentState } from 'common/CommonConstants';
import { StatusItemState } from 'common/status/StatusDocument';
import { trpc, useMutation } from 'client/lib/trpc';
import { useDeploymentClientState } from 'client/state/DeploymentClientState';
import type { OnLog } from 'client/state/LogState';
import { useDeploymentStatusTree } from 'client/state/useDeploymentStatusTree';
import { ComponentsStatus } from './ComponentsStatus/ComponentsStatus';
import { convertStatusTreeToComponentsStatusTree } from './ComponentsStatus/componentsStatusUtils';

interface OverviewStatusProps {
  onLog: OnLog;
}

export const OverviewStatus = ({ onLog }: OverviewStatusProps) => {
  const deploymentID = useDeploymentClientState((state) => state.document?.id);
  const deploymentUrl = useDeploymentClientState((state) => state.document?.url || '');
  const statusTree = useDeploymentStatusTree(deploymentID);
  const componentsWithValues = useDeploymentClientState((state) => state.document?.componentsWithValues || []);
  const isRunning = statusTree ? statusTree.deploymentStateID == DeploymentState.RUNNING : true;
  const coreStateID: CoreState = statusTree?.core.coreStateID || CoreState.INITIALIZING;
  const componentsStatusTree = useMemo(
    () => convertStatusTreeToComponentsStatusTree({ statusTree, componentsWithValues }),
    [statusTree, componentsWithValues]
  );

  const updateStackMutation = useMutation(trpc.deployment.updateStack, {});
  /*onMutate: () => setError(null),
    onSuccess: (data) => {
      if (data.status !== 'ok') return setError(data.status);
      window.location.href = data.url;
    },
  });*/

  if (!deploymentID) return null;

  // Don't show yellow in services while core is starting up
  let servicesItemStateID = statusTree?.services?.itemStateID;
  if (statusTree?.isStarting && (statusTree?.services?.items || []).length == 0) {
    servicesItemStateID = StatusItemState.GRAY;
  }

  const handleUpdateStack = async () => {
    // TODO: Disable button if stack not in the right state
    const timeUpdated = statusTree?.pendingChanges.timeUpdated;
    if (timeUpdated) {
      const ret = await updateStackMutation.mutateAsync({ deploymentID, timeUpdated });
      console.log('WE GOT', ret);
    }
  };

  let changes = <span></span>;
  let componentChanges = <div></div>;
  if (statusTree && statusTree.pendingChanges /* THIS LAST CHECK SHOULD BE UNNESSESARY LATER */) {
    const { pendingChanges } = statusTree;
    //console.log('PENDING!', pendingChanges);
    const { errorCode, errorDetails, components, state, timeUpdated } = pendingChanges;
    const age = timeUpdated ? (
      <span style={{ color: '#cccccc' }}>({formatDistanceToNow(new Date(timeUpdated), { addSuffix: true })})</span>
    ) : (
      ''
    );
    if (state == 'no-change') changes = <div>Everything update {age}</div>;
    if (state == 'error') {
      const errorMap: { [key: string]: string } = {
        'component error': 'Component error',
        'validation error': 'Validation error',
        'yaml error': 'Diploi.yaml - Invalid yaml',
        // TODO:
        // 'package url error'
        // 'config load failed'
        //'unexpected error'
      };
      const message = errorCode && errorCode in errorMap ? errorMap[errorCode] : `Unmapped error: ${errorCode}`;

      changes = (
        <>
          <div>
            {message} {age}
            <br></br>
            <br></br>
          </div>
          <div>
            {(errorDetails || '').split('\n').map((line, index) => (
              <div key={index}>{line}</div>
            ))}
          </div>
        </>
      );
    }
    if (state == 'modified') {
      changes = (
        <>
          <div>
            Stack modified {age} <button onClick={handleUpdateStack}>Update</button>
          </div>
        </>
      );
    }

    if (components.length) {
      componentChanges = (
        <>
          <div>
            <br />
            Modified Components
          </div>
          <div>
            {components.map((c, i) => {
              return (
                <div key={i}>
                  &nbsp;&nbsp;&nbsp;
                  {c.identifier} {c.state == 'new' && 'NEW'} {c.state == 'removed' && 'REMOVED'} {c.state == 'error' && 'ERROR'}{' '}
                  {c.state == 'modified' && 'MODIFIED'}
                </div>
              );
            })}
          </div>
        </>
      );
    }
  }

  return (
    <div style={{ opacity: isRunning && coreStateID == CoreState.RUNNING ? 1 : 0.5 }}>
      <ComponentsStatus
        deploymentID={deploymentID}
        deploymentUrl={deploymentUrl}
        componentsStatusTree={componentsStatusTree}
        componentsWithValues={componentsWithValues}
        onLog={onLog}
      />

      <div style={{ height: 32 }} />

      {/*<Typography component="div" style={{ marginBottom: '10px', background: '#930303', padding: '10px' }}>
        {changes}
        {componentChanges}
      </Typography>}
      <Typography component="div" style={{ marginBottom: '30px', padding: '10px' }}>
        <pre style={{ fontSize: '60%', marginTop: '30px' }}>{JSON.stringify(statusTree?.pendingChanges, null, 2)}</pre>
      </Typography>
      */}

      {/* <Stack>
        <StatusTree
          title="Setup"
          isRunning={isRunning}
          description="Status of the deployment setup process"
          itemStateID={
            statusTree
              ? Math.max(statusTree.images.itemStateID, statusTree.storage.itemStateID, statusTree.containers.itemStateID)
              : undefined
          }
        >
          <StatusTree.Storage isRunning={isRunning} storage={statusTree?.storage} components={componentsWithValues} />
          <StatusTree.Images isRunning={isRunning} images={statusTree?.images} components={componentsWithValues} />
          <StatusTree.Containers
            deploymentID={deploymentID}
            isRunning={isRunning}
            containers={statusTree?.containers}
            components={componentsWithValues}
            onLog={onLog}
          />
        </StatusTree>
      </Stack> */}
    </div>
  );
};
